function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-13.000000, -4.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(13.000000, 4.000000)"
}, React.createElement("path", {
  d: "M6.14135191,15.0163716 C5.52257307,15.19393 4.79560187,15.3232323 3.99058949,15.3232323 C1.42193419,15.3232323 -2.22044605e-13,14.0067563 -2.22044605e-13,14.0067563 C-2.22044605e-13,11.0742421 1.86548021,8.6969697 4.16666667,8.6969697 C5.54050965,8.6969697 6.75905518,9.54429376 7.51805836,10.8512278 C6.81490839,11.9970031 6.32535091,13.4303455 6.14135191,15.0163716 Z M4.16666667,8.14141414 C2.47912993,8.14141414 1.11111111,6.77339532 1.11111111,5.08585859 C1.11111111,3.39832185 2.47912993,2.03030303 4.16666667,2.03030303 C5.8542034,2.03030303 7.22222222,3.39832185 7.22222222,5.08585859 C7.22222222,6.77339532 5.8542034,8.14141414 4.16666667,8.14141414 Z"
}), React.createElement("path", {
  d: "M18.8676591,15.0964051 C18.6910317,13.4785684 18.1969,12.0162447 17.4819416,10.8512278 C18.2409448,9.54429376 19.4594903,8.6969697 20.8333333,8.6969697 C23.1345198,8.6969697 25,11.0742421 25,14.0067563 C25,14.0067563 23.2259115,15.3232323 20.6572562,15.3232323 C19.9791085,15.3232323 19.380888,15.2314731 18.8676591,15.0964051 Z M20.8333333,8.14141414 C19.1457966,8.14141414 17.7777778,6.77339532 17.7777778,5.08585859 C17.7777778,3.39832185 19.1457966,2.03030303 20.8333333,2.03030303 C22.5208701,2.03030303 23.8888889,3.39832185 23.8888889,5.08585859 C23.8888889,6.77339532 22.5208701,8.14141414 20.8333333,8.14141414 Z"
}), React.createElement("path", {
  d: "M18.1818182,16.5780886 C18.1818182,12.4430335 15.6379815,9.09090909 12.5,9.09090909 C9.36201847,9.09090909 6.81818182,12.4430335 6.81818182,16.5780886 C6.81818182,16.5780886 9.2895161,17.9393939 12.4637488,17.9393939 C15.6379815,17.9393939 18.1818182,16.5780886 18.1818182,16.5780886 Z"
}), React.createElement("circle", {
  cx: 12.5,
  cy: 4.16666667,
  r: 4.16666667
}))));

const SvgTeamIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "25px",
  height: "18px",
  viewBox: "0 0 25 18",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgTeamIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/team-icon.daa26ba2.svg";
export { ForwardRef as ReactComponent };